import { takeEvery, put, call, select, fork, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { meevoAppointment } from 'yoda-interfaces/lib/Account/AccountApi';
import FactorySaga from './FactorySaga';
import * as AppointmentActionTypes from '../actionTypes/AppointmentActionTypes';

import { getAppointmentDetails, getAppointmentPreferences } from '../selectors/appointmentSelector';

function* redirectAferDelay(url) {
    try {
        yield delay(10);
        // simulate as if you got data from redux
        // and let Appoint_Link_Success applied to state
        window.open(url, '_blank');
    } catch (err) {
        console.error('some error occured:', err);
    }
}

export function* getAppointmentSaga(action) {
    try {
        const storeId = action.payload.stores;

        // Caching of appointment details starts here
        let reduxStoreData;
        if (action.selectedService) {
            // lets check redux
            const appointmentDetailsFromRedux = yield select(getAppointmentDetails);
            const selector = storeId ? `byStoreID.${storeId}` : 'allStores';
            reduxStoreData = get(appointmentDetailsFromRedux, selector, {});
            const { data } = reduxStoreData;
            if (data) {
                yield put({
                    type: AppointmentActionTypes.GET_APPOINTMENT_LINK_SUCCESS,
                    payload: { data, isLoading: false },
                    storeId,
                });
                const url = data[action.selectedService] || data.decorating;
                // non blocking redirection
                yield fork(redirectAferDelay, url);

                return;
            }
        }
        // Caching of appointment details ends here

        // TO MAKE BACKWARD COMPATIBLE
        // This is case when newly added services needs to be reverted from  payload.service -> param (api)
        // in action
        const appointmentPreferences = yield select(getAppointmentPreferences);
        const newAction = {
            // type & selectedService, payload.stores should not be changed
            ...action,
            ...(appointmentPreferences.overrideServiceParam && {
                payload: {
                    ...action.payload,
                    service: appointmentPreferences.overrideServiceParam,
                },
            }),
        };

        // if not present in redux, lets do fresh call
        const response = yield call(FactorySaga, meevoAppointment, newAction, undefined, false);

        const data = {};
        if (response.isSuccess) {
            get(response, 'response.data.data', []).forEach((item) => {
                data[item.service] = item.url;
            });

            yield put({
                type: AppointmentActionTypes.GET_APPOINTMENT_LINK_SUCCESS,
                payload: { data, isLoading: false },
                storeId,
            });
            if (action.selectedService) {
                // this means that a perticular store's service is selected and
                // user wants to see in new tab
                const url = data[action.selectedService] || data.decorating;
                // non blocking redirection
                yield fork(redirectAferDelay, url);
            }
        } else {
            const error = get(response, 'response.data', { errorCode: '' });
            yield put({
                type: AppointmentActionTypes.GET_APPOINTMENT_LINK_ERROR,
                payload: { error },
                storeId: action.payload.stores,
            });
        }
    } catch (err) {
        const errorPayload = {
            error: {
                errorMessage: err.message,
                errorCode: 'EXCEPTION_IN_APPOINTMENT_SAGA',
            },
            isLoading: false,
        };
        yield put({
            type: AppointmentActionTypes.GET_APPOINTMENT_LINK_ERROR,
            payload: errorPayload,
            storeId: action.payload.stores,
        });
    }
}

const watchAppointmentSaga = function* watchAppointmentSaga() {
    yield takeEvery(AppointmentActionTypes.GET_APPOINTMENT_LINK, getAppointmentSaga);
};
watchAppointmentSaga.sagaName = 'watchAppointmentSaga';

export default watchAppointmentSaga;
